/*
 * @providesModule SKZTournamentTemplateSet
 *
 */

import _ from 'lodash';
import SKZTournament from 'SKZTournament';
import SKZUser, {SKZUserRecord} from 'SKZUser';

export class SKZTournamentTemplateSetRecord {
  id: number;
  name: string;
  friend?: boolean;
  current_challenge_count?: number; // required if friends flag is true
  max_challenge_count?: number; // required if friends flag is true
  seconds_to_next_challenge?: number;
  challenge_refresh_seconds?: number;
  tournaments: Array<SKZTournament>;
  description: string;
  background_image_url?: string;
}

export default class SKZTournamentTemplateSet extends SKZTournamentTemplateSetRecord {
  constructor(keyValueSource: Object) {
    super();
    const templateSet = _.create(SKZTournamentTemplateSet.prototype, keyValueSource);
    templateSet.tournaments =
      templateSet.tournaments?.map(
        (tournament: Object): SKZTournament => new SKZTournament(tournament)
      ) || [];
    return templateSet;
  }

  static make(
    tournamentTemplateSets: Array<SKZTournamentTemplateSetRecord>
  ): Array<SKZTournamentTemplateSet> {
    if (Array.isArray(tournamentTemplateSets)) {
      return _.map(
        tournamentTemplateSets,
        (tournamentTemplateSetRecord: SKZTournamentTemplateSetRecord): SKZTournamentTemplateSet => {
          // TS doesn't include the tournament's set id with the tournament object, so we manually add it here
          _.forEach(tournamentTemplateSetRecord.tournaments, (tournament: Object) => {
            tournament['set_id'] = tournamentTemplateSetRecord.id;
          });
          return new SKZTournamentTemplateSet(tournamentTemplateSetRecord);
        }
      );
    }
    return [];
  }

  getBackgroundImageUrl(): string {
    return this.background_image_url;
  }

  getDescription(): string {
    return this.description;
  }

  getId(): number {
    return this.id;
  }

  getName(): string {
    return this.name;
  }

  getTournaments(): Array<SKZTournament> {
    return this.tournaments;
  }

  isAllCashTournaments(): boolean {
    return this.tournaments.reduce((acc: boolean, tournament: SKZTournament): boolean => {
      return acc && tournament.isCashTournament();
    }, true);
  }

  isAllZTournaments(): boolean {
    return this.tournaments.reduce((acc: boolean, tournament: SKZTournament): boolean => {
      return acc && tournament.isZTournament();
    }, true);
  }

  isAllTicketzTournaments(): boolean {
    return this.tournaments.reduce((acc: boolean, tournament: SKZTournament): boolean => {
      return acc && tournament.isTicketzTournament();
    }, true);
  }

  userCanAffordAnyTemplate(userInfo: SKZUserRecord | SKZUser): boolean {
    return this.tournaments.reduce((acc: boolean, tournament: SKZTournament): boolean => {
      return (
        acc ||
        (tournament.z_fee <= userInfo?.z_balance && tournament.cash_fee <= userInfo?.cash_balance)
      );
    }, false);
  }
}
